import { createContext } from 'react';

const WorkspaceContext = createContext<{ switch: (callback: () => void) => void }>({
  switch: () => {},
});

export default WorkspaceContext;
